import React from "react";
import Swal from "sweetalert2";
import doc7Service from "../../services/doc7.service";

const DeleteDoc7 = (props: any) => {
  const { doc7 } = props;
  const onDelete = () => {
    Swal.fire({
      title: `คุณต้องการลบ เอกสาร ${
        doc7.curri.type === "tqf" ? "มคอ." : "อชว."
      }7?`,
      text: `ปีการศึกษา ${doc7.year} หลักสูตร ${doc7.curri.shortName}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        doc7Service
          .deleteDoc7(doc7.id)
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "ลบเอกสารสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "ผิดพลาดตรวจอสอบอีกครั้ง",
              showConfirmButton: true,
            });
          });
      }
      // console.log("ไม่ลบนะแล้วปิดไปซือๆ");
    });
  };
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-danger text-white ms-1"
        onClick={onDelete}
      >
        <i className="bi bi-trash3"></i> ลบ
      </button>
    </>
  );
};

export default DeleteDoc7;
